export const mainColor = '#50b7f5';
export const mainBackgroundColor = '#e6ecf0';
export const desktopScreenMinWidth = '600px';